export default __webpack_public_path__ + "static/media/ab-girl.b08a0ba3.webp";